const openTabContent = (evt) => {
  var i, content, tabs;
  var contentId = evt.target.getAttribute('data-tab');

  content = document.getElementsByClassName("product-information__content");
  tabs = document.getElementsByClassName("product-information__tab");

  // If the clicked tab is already active, close it
  if (evt.currentTarget.classList.contains('active')) {
    for (i = 0; i < content.length; i++) {
      if (content[i].getAttribute('data-tab-id') === contentId) {
        content[i].classList.remove("active");
      }
    }
    evt.currentTarget.classList.remove("active");
  } else {
    // Otherwise, open the clicked tab and close all others
    for (i = 0; i < content.length; i++) {
      content[i].classList.remove("active");
    }
    for (i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove("active");
    }

    var matchingContent = document.querySelectorAll(`[data-tab-id="${contentId}"]`);
    matchingContent.forEach(function(content) {
      content.classList.add("active");
    });

    evt.currentTarget.classList.add("active");
  }
}

// Add event listeners to the tabs
var tabs = document.querySelectorAll('.product-information__tab');

tabs.forEach(function(tab) {
  tab.addEventListener('click', openTabContent);
});

// Throttle function
function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function() {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function() {
        if ((Date.now() - lastRan) >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  }
}

// Check if any tab is active
function isAnyTabActive() {
  const tabs = document.querySelectorAll('.product-information__tab');
  return Array.from(tabs).some(tab => tab.classList.contains('active'));
}

// Click the first tab
function clickFirstTab() {
  const firstTab = document.querySelector('.product-information__tab');
  if (firstTab) {
    firstTab.click();
  }
}

// Add event listeners
document.addEventListener('DOMContentLoaded', (event) => {
  if (window.matchMedia('(min-width: 990px)').matches) {
    clickFirstTab();
  }
});

window.addEventListener('resize', throttle(() => {
  if (window.matchMedia('(min-width: 990px)').matches && !isAnyTabActive()) {
    clickFirstTab();
  }
}, 200)); // Throttle resize events to once every 200ms